var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#252153"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0044 27C19.7931 27 19.6146 26.9281 19.4688 26.7844C19.3229 26.6406 19.25 26.4625 19.25 26.25V20.75H13.75C13.5375 20.75 13.3594 20.6785 13.2156 20.5356C13.0719 20.3927 13 20.2156 13 20.0044C13 19.7931 13.0719 19.6146 13.2156 19.4688C13.3594 19.3229 13.5375 19.25 13.75 19.25H19.25V13.75C19.25 13.5375 19.3215 13.3594 19.4644 13.2156C19.6073 13.0719 19.7844 13 19.9956 13C20.2069 13 20.3854 13.0719 20.5312 13.2156C20.6771 13.3594 20.75 13.5375 20.75 13.75V19.25H26.25C26.4625 19.25 26.6406 19.3215 26.7844 19.4644C26.9281 19.6073 27 19.7844 27 19.9956C27 20.2069 26.9281 20.3854 26.7844 20.5312C26.6406 20.6771 26.4625 20.75 26.25 20.75H20.75V26.25C20.75 26.4625 20.6785 26.6406 20.5356 26.7844C20.3927 26.9281 20.2156 27 20.0044 27Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconFilled);
export default __webpack_public_path__ + "static/media/plusIconFilled.d798b63e93e3dcddd8ff9e64dcc53d8f.svg";
export { ForwardRef as ReactComponent };